import { goto } from '$app/navigation';
import { derived, get } from 'svelte/store';
import filters from '../store';
import { formatFiltersUrlSearchParams, stringToKebabCase } from '@resider/utils';

export const filtersSearchParams = derived(filters, ($filters) =>
	formatFiltersUrlSearchParams($filters)
);

/**
 * 
 * @param {URL} url 
 * @param {string} lang 
 */
export default function submit(url, lang = 'pl') {
	const searchParams = get(filtersSearchParams);

	const offerType = get(filters).offer_type === 'rent' ? 'wynajem' : 'sprzedaz';
	const city = get(filters).city?.length
		? get(filters)
			.city?.map((/** @type {String} */ x) => x.toLowerCase())
			.join()
		: 'warszawa';
	const district = get(filters).district?.length
		? `/${stringToKebabCase(get(filters).district.join())}`
		: '';
	const subdistrict = get(filters).subdistrict?.length
		? `/${stringToKebabCase(get(filters).subdistrict.join())}`
		: '';

	searchParams.delete('offer_type');
	searchParams.delete('city');
	searchParams.delete('district');
	searchParams.delete('subdistrict');

	const submitPathname = `/${lang}/odkrywaj/${offerType}/${city}${district}${subdistrict}?${searchParams.toString()}`;

	goto(submitPathname);
}
